/* eslint-disable max-len */
import styles from "./Pricing.module.css";
import ButtonArr from "../../components/Button/ButtonArr";
import { useEffect, useState } from "react";
import PriceCard from "../../components/Pricing/components/PriceCard";
import { Grid } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
// import Select from "@mui/material/Select";
// import MenuItem from "@mui/material/MenuItem";
// import InputLabel from "@mui/material/InputLabel";
// import FormControl from "@mui/material/FormControl";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import axios from "axios";
// import ComingSoon from "../../assets/images/comingsoontag.svg";

// --| Rewrite the comingsoon tag on each table

// USED TO STYLE THE TABLE
const tableCellHeaderStyle = { fontWeight: "400", fontSize: "18px", lineHeight: "21.6px", borderBottom: "0px", color: "rgba(169, 169, 169, 1)", padding: "0px 16px 35px 16px" };
const tableSubDescStyle = { fontWeight: "700", fontSize: "24px", lineHeight: "36px", borderBottom: "0px" };
// const tableSubHeaderStyle = { fontWeight: "700", fontSize: "20px", lineHeight: "24px", padding: "50px 16px 16px 16px", borderBottom: "0px" };

const PRICING_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/v1/pricing-plans?include_variants=true`;
// const EXCHANGE_RATES = {
//   USD: 1500,  // 1 USD = 1500 NGN
//   GBP: 1900,  // 1 GBP = 1900 NGN
//   EUR: 1600,  // 1 EUR = 1600 NGN
//   GHS: 120,   // 1 GHS = 120 NGN
//   ZAR: 80,    // 1 ZAR = 80 NGN
//   KES: 12     // 1 KES = 12 NGN
// };

const PricePage = () => {
  const [pricingModels, setPricingModels] = useState([]);
  // const [selectedCurrency, setSelectedCurrency] = useState("");
  // const [convertedPricing, setConvertedPricing] = useState([]);

  const createData = (name, basic, premium, enterprise) => {
    return { name, basic, premium, enterprise };
  };

  const tableone = [
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Users</p></span>, "Up to 99 Students", "Up to 699 Students", "From 699 Students"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Payment Management</p>  </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Analytics Dashboard</p>  </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Sessions</p> </span>, "Unlimited", "Unlimited", "Unlimited"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Terms</p> </span>, "Unlimited", "Unlimited", "Unlimited"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Classes</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Subjects</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Assesments</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Lesson Notes</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>CBT</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Applicant Portal</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Invoice Notifications</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Third Party Integrations</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Enrollments and Application</p> </span>, "50 student application Per enrollment", "Unlimited", "Unlimited"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Online Support</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>AI Web Chat</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Sending Bulk Emails</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Guides and Explainer Videos</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Report Templates </p> </span>, "1", "unlimited", "unlimited"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Data Export(Csv, Doc, Pdf) </p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Batch Data Import </p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Branding </p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Mobile App </p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Lesson Note Review </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Attendance </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>CA Audits </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Hostel Management </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>School Plans/Calendar</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Access Control </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Audit logs </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Inventory management </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Library Managment</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Event Management</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Account Transfer</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Question Bank</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Exam Timetable</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Enrollment Examination</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Custom Academic Reports</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Roles and Permissions</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Email Subscriber List</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Email Templates</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Multi School Managment</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Dedicated Server</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Account Manager</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Custom Features</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>School Custom Domain</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />)
  ];

  const handleGetStart = () => {
    window.open(process.env.REACT_APP_URL, "_blank");
  };

  // const CURRENCIES = [
  //   // { code: "USD", symbol: "$", name: "US Dollar" },
  //   { code: "NGN", symbol: "₦", name: "Nigerian Naira" }
  //   // { code: "GHS", symbol: "GH₵", name: "Ghanaian Cedi" },
  //   // { code: "ZAR", symbol: "R", name: "South African Rand" },
  //   // { code: "KES", symbol: "KSh", name: "Kenyan Shilling" }
  // ];

  // const convertPrices = (models, currencyCode) => {
  //   const selectedCurrencyObj = CURRENCIES.find(curr => curr.code === currencyCode);

  //   const converted = models.map(model => {
  //     const basePriceNGN = model.price;

  //     if (currencyCode === "NGN") {
  //       return {
  //         ...model,
  //         convertedPrice: basePriceNGN,
  //         currencySymbol: selectedCurrencyObj.symbol,
  //         currencyCode,
  //         displayAmount: `${selectedCurrencyObj.symbol}${basePriceNGN}`,
  //         originalPrice: basePriceNGN,
  //         originalCurrency: "NGN"
  //       };
  //     }

  //     const rate = EXCHANGE_RATES[currencyCode];
  //     if (!rate) {
  //       return {
  //         ...model,
  //         convertedPrice: basePriceNGN,
  //         currencySymbol: "₦",
  //         currencyCode: "NGN",
  //         displayAmount: `₦${basePriceNGN}`,
  //         originalPrice: basePriceNGN,
  //         originalCurrency: "NGN"
  //       };
  //     }

  //     const convertedPrice = Math.ceil(basePriceNGN / rate);

  //     return {
  //       ...model,
  //       convertedPrice,
  //       currencySymbol: selectedCurrencyObj.symbol,
  //       currencyCode,
  //       displayAmount: `${selectedCurrencyObj.symbol}${convertedPrice}`,
  //       originalPrice: basePriceNGN,
  //       originalCurrency: "NGN"
  //     };
  //   });

  //   setConvertedPricing(converted);
  // };

  // const handleCurrencyChange = (event) => {
  //   const newCurrency = event.target.value;
  //   setSelectedCurrency(newCurrency);
  //   convertPrices(pricingModels, newCurrency);
  // };

  const fetchPricingModels = async () => {
    try {
      const res = await axios.get(PRICING_ENDPOINT);
      const filteredModels = res?.data?.data?.filter(model => model?.model_name !== "Partner");
      const sortedModels = filteredModels?.sort((a, b) => a?.price - b?.price);

      setPricingModels(sortedModels);
      // convertPrices(filteredModels, "NGN");
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err.response?.data?.message || "Error fetching pricing models");
    }
  };

  useEffect(() => {
    fetchPricingModels();
  }, []);

  // const reformatFreePricing = () =>{
  //   const free_model = pricingModels?.filter((model) => model.model_name === "Free");
  //   return({
  //     name: free_model.model_name,
  //     id: free_model.id,
  //     description: free_model.description,
  //     price: free_model.price

  //   })
  // }
  const freeFeatures = [
    "Up to 99 Students", "Comprehensive Dashboard", "Payments Management", "Reports Management", "Up to 50 Applications/Enrollment", "NULL", "NULL", "NULL"
  ];

  const proFeatures = [
    "Up to 699 Students", "Comprehensive Dashboard", "Payments Management", "Reports Management", "Unlimited Applications/Enrollments", "Hostel Management", "Examination Timetable", "Roles and Permissions"
  ];
  const enterpiseFeatures = [
    "From 699 Students", "Comprehensive Dashboard", "Payments Management", "Reports Management", "Unlimited Applications/Enrollments", "Hostel Management", "Examination Timetable", "Roles and Permissions"
  ];

  return (
    <div>
      <div className={`${styles.herosectionbcg}`}>
        <div className={`${styles.container}`}>
          <div className={`${styles.contmargin}`}>
            <div className={`${styles.priceheader}`}>
              <h1>
              With little or no cash you can get started with managing your school and
              teams.
              </h1>
              <h4>
              Empowering Schools, Engaging Students, and Connecting Parents, all
              in one platform.
              </h4>
              <div className={`${styles.getstartedbtn}`}>
                <ButtonArr onClick={handleGetStart} title="Get Started" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* PRICING */}
      <div className={`${styles.pricingcontainer}`}>
        <div className={`${styles.container}`}>
          <div className={`${styles.contmargin}`}>
            <div className={`${styles.pricingheader}`}>
              <h3>Shelf21 Pricing Options</h3>
              <p>
                Record and report on safeguarding information including
                background checks, and safer recruitment trainingRecord and
                report on safeguarding.
              </p>
            </div>
            {/* <div className={`${styles.currencySelector}`} style={{ marginTop: "20px", marginBottom: "20px", display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
              <FormControl sx={{ minWidth: 250 }} size="small">
                <InputLabel id="currency-select-label">Select Currency</InputLabel>
                <Select
                  labelId="currency-select-label"
                  value={selectedCurrency}
                  label="Select Currency"
                  onChange={handleCurrencyChange}
                >
                  {CURRENCIES.map(currency => (
                    <MenuItem key={currency.code} value={currency.code}>
                      {currency.name} ({currency.symbol})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div> */}
            <div className={`${styles.shelfpricing}`}>
              <Grid container spacing={2} justifyContent="center">
                {pricingModels.map((model, index) => (
                  <Grid item lg={4} md={6} sm={6} xs={12} key={index}>
                    <PriceCard
                      amount={`${model.currencySymbol || "₦"}${model.price}`}
                      price={model.price}
                      payType="Month"
                      planType={model.name}
                      planDescription={model.description}
                      modelId={model.id}
                      status={model.active}
                      features={model.name === "Free" ? freeFeatures : model.name === "Pro" ? proFeatures : model.name === "Enterprise" ? enterpiseFeatures : []}
                      variant={model.has_variant}
                      variants={model.variants}
                      currencyCode={model.currencyCode}
                    />
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
        </div>
      </div>
      {/* PLANS AND FEATURES */}
      <div className={`${styles.container}`}>
        <div className={`${styles.contmargin}`}>
          <div className={`${styles.planandfeatures}`}>
            <div className={`${styles.compareplansheader}`}>
              <h3>Compare Plans</h3>
              <p>
                  Choose a subscription that fits your current need and get
                  right on it.
              </p>
            </div>
            <TableContainer component={Paper} sx={{ boxShadow: "0px 0px 0px 0px" }}>
              <Table sx={{ minWidth: 650, borderColor: "white" }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={tableSubDescStyle}></TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}>Basic</TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}>Pro</TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}>Enterprise</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="center" sx={tableCellHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableCellHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableCellHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableCellHeaderStyle}>On request</TableCell>
                  </TableRow>
                  <TableRow>
                    {/* <TableCell sx={{ fontWeight: "700", fontSize: "20px", lineHeight: "24px", borderBottom: "0px" }}>WORKSPACE MANAGEMENT</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableone.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:nth-of-type(odd)": { backgroundColor: "#F9F9FB" }
                      }}
                    >
                      <TableCell component="th" scope="row" sx={{ borderBottom: "0px" }}>
                        {row.name}
                      </TableCell>
                      <TableCell align="center" sx={{ borderBottom: "0px" }}>{row.basic}</TableCell>
                      <TableCell align="center" sx={{ borderBottom: "0px" }}>{row.premium}</TableCell>
                      <TableCell align="center" sx={{ borderBottom: "0px" }}>{row.enterprise}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                {/* SECOND TABLE */}
                {/* <TableHead sx={{ marginTop: "50px" }}>
                  <TableRow>
                    <TableCell sx={tableSubHeaderStyle}>SCHOOL BRANDING</TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}></TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}></TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}></TableCell>
                  </TableRow>
                </TableHead> */}
                {/* THIRD TABLE */}
                {/* <TableHead>
                  <TableRow>
                    <TableCell sx={tableSubHeaderStyle}>EXPORTS</TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                  </TableRow>
                </TableHead> */}

                {/* FOURTH TABLE */}
                {/* <TableHead>
                  <TableRow>
                    <TableCell sx={tableSubHeaderStyle}>SUPPORTS</TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                  </TableRow>
                </TableHead> */}
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricePage;
